import accessesIcon from '../assets/assesses/accesses.svg'
import truckIcon from '../assets/equipment/truck.svg'
import diplomaIcon from '../assets/sidemenu/diploma-active.svg'
import boxIcon from '../assets/sidemenu/box-active.svg'
import productionIcon from '../assets/home/production.svg'
import localIcon from '../assets/sidemenu/local-active.svg'
import clipboardIcon from '../assets/sidemenu/clipboard-active.svg'
import steelIcon from '../assets/home/steel.svg'
import resourceIcon from '../assets/home/resource.svg'
import serviceIcon from '../assets/home/service.svg'
import hangerIcon from '../assets/home/hanger.svg'
import companiesIcon from '../assets/home/companies.svg'
import vendasAcoIcon from '../../src/assets/home/orders.svg'
import collectionsIcon from '../assets/home/shirt.svg'
import occurrenceIcon from '../assets/home/receipt.svg'
import financialIcon from '../assets/home/receipt.svg'
import fiscalIcon from '../assets/certificates/AddCertificate/invoice.svg'
import { hasPermission, normalizePermissions } from '../utils/permissions'

export interface ModuleConfig {
  name: string
  path: string
  image: string
  section: string
  permission: string
  dependencies?: string[]
}


export const industrialModules: ModuleConfig[] = [
  {
    name: 'Certificados',
    path: 'certificates',
    image: diplomaIcon,
    section: 'Aplicações',
    permission: 'certificates',
    dependencies: ['stock']
  },
  {
    name: 'Estoque',
    path: 'stock',
    image: boxIcon,
    section: 'Aplicações',
    permission: 'stock'
  },
  {
    name: 'Produção',
    path: 'production',
    image: productionIcon,
    section: 'Aplicações',
    permission: 'production',
    dependencies: ['stock', 'orders']
  },
  {
    name: 'Financeiro',
    path: 'financial/entry',
    image: financialIcon,
    section: 'Aplicações',
    permission: 'financial'
  },
  {
    name: 'Vendas Aço',
    path: 'steel',
    image: vendasAcoIcon,
    section: 'Aplicações',
    permission: 'orders'
  },
  {
    name: 'Roterização',
    path: 'router',
    image: localIcon,
    section: 'Aplicações',
    permission: 'router'
  },
  {
    name: 'Fiscal',
    path: 'invoice',
    image: fiscalIcon,
    section: 'Aplicações',
    permission: 'fiscal'
  },

  {
    name: 'Empresas',
    path: 'companies',
    image: companiesIcon,
    section: 'Banco de dados',
    permission: 'public'
  },
  {
    name: 'Pessoas',
    path: 'people',
    image: accessesIcon,
    section: 'Banco de dados',
    permission: 'accesses'
  },
  {
    name: 'Equipamentos',
    path: 'equipment',
    image: truckIcon,
    section: 'Banco de dados',
    permission: 'equipment'
  },
  {
    name: 'Serviços',
    path: 'service',
    image: serviceIcon,
    section: 'Banco de dados',
    permission: 'services'
  },
  {
    name: 'Ocorrências',
    path: 'occurrences',
    image: occurrenceIcon,
    section: 'Banco de dados',
    permission: 'public'
  }
]

// Módulos específicos do tenant 2 (Fashion)
export const fashionModules: ModuleConfig[] = [
  {
    name: 'Desenvolvimento de Produto',
    path: 'product-development',
    image: collectionsIcon,
    section: 'Aplicações',
    permission: 'public'
  },
  {
    name: 'Vendas',
    path: 'fashion',
    image: hangerIcon,
    section: 'Aplicações',
    permission: 'orders'
  },
  {
    name: 'Produção',
    path: 'production-fashion',
    image: productionIcon,
    section: 'Aplicações',
    permission: 'production',
    dependencies: ['orders']
  },
  {
    name: 'Financeiro',
    path: 'financial/entry',
    image: financialIcon,
    section: 'Aplicações',
    permission: 'financial'
  },
  {
    name: 'Estoque',
    path: 'stock',
    image: boxIcon,
    section: 'Aplicações',
    permission: 'stock'
  },
  {
    name: 'Roterização',
    path: 'router',
    image: localIcon,
    section: 'Aplicações',
    permission: 'router'
  },

  {
    name: 'Empresas',
    path: 'companies',
    image: companiesIcon,
    section: 'Banco de dados',
    permission: 'public'
  },
  {
    name: 'Pessoas',
    path: 'people',
    image: accessesIcon,
    section: 'Banco de dados',
    permission: 'accesses'
  },
  {
    name: 'Equipamentos',
    path: 'equipment',
    image: truckIcon,
    section: 'Banco de dados',
    permission: 'equipment'
  },
  {
    name: 'Serviços',
    path: 'service',
    image: serviceIcon,
    section: 'Banco de dados',
    permission: 'services'
  }
]


export function hasModulePermission(module: ModuleConfig, userPermissions: string[]): boolean {

  if (module.permission === 'public') {
    console.log('🧩 [MODULE-PERMISSION] Módulo público liberado', {
      module: module.path,
      permission: module.permission,
    })
    return true
  }

  const normalizedPermissions = normalizePermissions(userPermissions)
  const hasMainPermission = hasPermission(normalizedPermissions, module.permission)

  console.log('🧩 [MODULE-PERMISSION] Avaliação de módulo', {
    module: module.path,
    modulePermission: module.permission,
    normalizedPermissions,
    hasMainPermission,
    dependencies: module.dependencies,
  })

  if (hasMainPermission) {
    return true
  }

  return false
}


export function getModulesForTenant(tenantId: number | null): ModuleConfig[] {

  if (tenantId === null) return []


  if (tenantId === 2) {
    return fashionModules
  }


  return industrialModules
}


export function getModulesForTenantWithPermissions(tenantId: number | null, userPermissions: string[]): ModuleConfig[] {
  if (tenantId === null) return []

  const allModules = getModulesForTenant(tenantId)

  return allModules.filter(module => hasModulePermission(module, userPermissions))
}


export function getModulesBySection(tenantId: number | null) {
  if (tenantId === null) return {} as Record<string, ModuleConfig[]>

  const modules = getModulesForTenant(tenantId)

  const sections = modules.reduce((acc, module) => {
    if (!acc[module.section]) {
      acc[module.section] = []
    }
    acc[module.section].push(module)
    return acc
  }, {} as Record<string, ModuleConfig[]>)

  // Garantir ordem: Aplicações primeiro, depois Banco de dados
  const orderedSections: Record<string, ModuleConfig[]> = {}

  if (sections['Aplicações']) {
    orderedSections['Aplicações'] = sections['Aplicações']
  }

  if (sections['Banco de dados']) {
    orderedSections['Banco de dados'] = sections['Banco de dados']
  }

  return orderedSections
}


export function getModulesBySectionWithPermissions(tenantId: number | null, userPermissions: string[]) {
  if (tenantId === null) return {} as Record<string, ModuleConfig[]>

  const modules = getModulesForTenantWithPermissions(tenantId, userPermissions)

  const sections = modules.reduce((acc, module) => {
    if (!acc[module.section]) {
      acc[module.section] = []
    }
    acc[module.section].push(module)
    return acc
  }, {} as Record<string, ModuleConfig[]>)



  // Garantir ordem: Aplicações primeiro, depois Banco de dados
  const orderedSections: Record<string, ModuleConfig[]> = {}

  if (sections['Aplicações']) {
    orderedSections['Aplicações'] = sections['Aplicações']
  }

  if (sections['Banco de dados']) {
    orderedSections['Banco de dados'] = sections['Banco de dados']
  }

  return orderedSections
}


export function canEditStock(userPermissions: string[]): boolean {
  return hasPermission(userPermissions, 'edit-stock')
}